module.exports = __webpack_public_path__ + "static/media/45.261e181c.jpg";